import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "", password: "" });
  const [address, setAddress] = useState({ line1: "", line2: "", postal_code: "", city: "", country: "France" });
  const [loading, setLoading] = useState(false);
  const [sentTo, setSentTo] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await register({ ...form, billing_address: address });
      if (r.verification_sent) {
        setSentTo(r.email || form.email);
      } else {
        toast.success("Compte créé ✿");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    try {
      await api.post("/auth/resend-verification", { email: sentTo });
      toast.success("E-mail renvoyé ✿");
    } catch {
      toast.error("Impossible de renvoyer l'e-mail");
    }
  };

  if (sentTo) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center">
        <p className="overline text-berulia-rosedeep">Une dernière étape</p>
        <h1 className="font-heading text-4xl md:text-5xl mt-3">Vérifiez votre <span className="font-serif-italic">e-mail</span></h1>
        <div className="mt-10 bg-white border border-berulia-border p-8">
          <p className="text-berulia-inkdeep leading-relaxed">
            Nous avons envoyé un lien de confirmation à
          </p>
          <p className="font-heading text-lg mt-2">{sentTo}</p>
          <p className="text-sm text-berulia-inkmuted italic mt-6">
            Cliquez sur le bouton dans l'e-mail pour activer votre compte. Le lien est valable 24 h.
          </p>
          <button onClick={resend} className="mt-8 overline link-underline text-berulia-rosedeep">
            Renvoyer l'e-mail →
          </button>
        </div>
        <p className="text-center text-sm mt-6">
          Déjà confirmé ? <Link to="/connexion" className="link-underline overline">Connexion</Link>
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <p className="overline text-berulia-rosedeep text-center">Nouveau ici ?</p>
      <h1 className="font-heading text-5xl text-center mt-3">Créer un <span className="font-serif-italic">compte</span></h1>
      <form onSubmit={submit} className="mt-12 space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <label><span className="overline">Prénom</span><input data-testid="reg-firstname" required value={form.first_name} onChange={e=>setForm({...form, first_name:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
          <label><span className="overline">Nom</span><input data-testid="reg-lastname" required value={form.last_name} onChange={e=>setForm({...form, last_name:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
        </div>
        <label className="block"><span className="overline">Email</span><input data-testid="reg-email" required type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
        <label className="block"><span className="overline">Téléphone</span><input data-testid="reg-phone" required type="tel" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
        <p className="overline text-berulia-inkmuted pt-2">Adresse de livraison</p>
        <label className="block"><span className="overline">Adresse</span><input data-testid="reg-line1" required value={address.line1} onChange={e=>setAddress({...address, line1:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
        <label className="block"><span className="overline">Complément</span><input data-testid="reg-line2" value={address.line2} onChange={e=>setAddress({...address, line2:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
        <div className="grid grid-cols-2 gap-3">
          <label><span className="overline">Code postal</span><input data-testid="reg-postal" required value={address.postal_code} onChange={e=>setAddress({...address, postal_code:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
          <label><span className="overline">Ville</span><input data-testid="reg-city" required value={address.city} onChange={e=>setAddress({...address, city:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
        </div>
        <label className="block"><span className="overline">Mot de passe</span><input data-testid="reg-password" required type="password" minLength={6} value={form.password} onChange={e=>setForm({...form, password:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3"/></label>
        <button disabled={loading} data-testid="reg-submit" className="w-full bg-berulia-rosedeep text-berulia-inkdeep overline py-4 hover:bg-berulia-rose">{loading?"…":"Créer mon compte →"}</button>
      </form>
      <p className="text-center text-sm mt-6">Déjà cliente ? <Link to="/connexion" className="link-underline overline">Connexion</Link></p>
    </div>
  );
}
